import { Dropdown, Menu } from 'antd';
import React, { useState } from 'react';
import LanguageSwitchModal from '@web-common/components/LanguageSwitchModal/languageSwitchModal';
import { DEFAULT_LANG, apiHolder } from 'api';
const systemApi = apiHolder.api.getSystemApi();
let langTemp = DEFAULT_LANG;
const LangMenusComp = props => {
    const { menuClassName, labelClassName, iconClassName, iconColor = '#fff' } = props;
    const [showModal, setShowModal] = useState(false);
    const [lang] = useState(systemApi.getSystemLang());
    const langMap = {
        en: 'English',
        zh: '简体中文',
        'zh-trad': '繁體中文',
    };
    const langMenus = (React.createElement(Menu, { className: menuClassName }, Object.keys(langMap).map(currKey => {
        return (React.createElement(Menu.Item, { key: currKey, onClick: ({ domEvent }) => {
                domEvent.stopPropagation();
                langTemp = currKey;
                if (langTemp !== lang) {
                    setShowModal(true);
                }
            } }, langMap[currKey]));
    })));
    const restartApp = () => {
        if (process.env.BUILD_ISELECTRON) {
            systemApi.reLaunchApp();
        }
        else {
            if (window.isInSafari) {
                location.reload();
            }
            else {
                history.go();
            }
        }
    };
    const getLanguageLabel = () => {
        return langMap[lang] || DEFAULT_LANG;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Dropdown, { overlay: langMenus },
            React.createElement("div", null,
                React.createElement("span", { className: labelClassName }, getLanguageLabel()),
                React.createElement("svg", { width: "8", height: "8", viewBox: "0 0 8 8", fill: "none", className: iconClassName },
                    React.createElement("path", { d: "M4.39043 6.51196L7.35012 2.81235C7.61203 2.48497 7.37894 2 6.95969 2L1.04031 2C0.621061 2 0.387974 2.48496 0.64988 2.81235L3.60957 6.51196C3.80973 6.76216 4.19027 6.76216 4.39043 6.51196Z", fill: iconColor })))),
        React.createElement(LanguageSwitchModal, { visible: showModal, lang: langTemp, onClose: (onOk) => {
                setShowModal(false);
                if (onOk) {
                    systemApi.setSystemLang(langTemp);
                    restartApp();
                }
            } })));
};
export default LangMenusComp;
